module.exports = __webpack_public_path__ + "img/infinity1.2a055543.jpg";